import { Layout, Typography, Row, Col, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import RequestAccessModal from "../components/RequestAccessModal";
import SubprocessorCard from "../components/SubprocessorCard";
import { useState } from "react";
import { CustomFooter } from "../components/Footer";

// Import JSON data
import subprocessorsData from "../data/subprocessors.json";
import LogoHeader from "../components/LogoHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function SubprocessorsPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const performSearch = (searchValue) => {
    if (!searchValue.trim()) {
      setSearchTerm("");
      setSearchResults([]);
      return;
    }

    const searchLower = searchValue.toLowerCase();
    const subprocessorsInfo = subprocessorsData;

    // Search through both leveragedSystems and interconnections
    const allSubprocessors = [
      ...subprocessorsInfo.leveragedSystems,
      ...subprocessorsInfo.interconnections,
    ];

    const filteredSubprocessors = allSubprocessors.filter(
      (subprocessor) =>
        subprocessor.name.toLowerCase().includes(searchLower) ||
        subprocessor.description.toLowerCase().includes(searchLower)
    );

    setSearchTerm(searchValue);
    setSearchResults(filteredSubprocessors);
  };

  const onSearch = (value) => {
    performSearch(value);
  };

  // Type the imported data
  const subprocessorsInfo = subprocessorsData;
  const leveragedSystemsSubprocessors = subprocessorsInfo.leveragedSystems;
  const interconnectionsSubprocessors = subprocessorsInfo.interconnections;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LogoHeader />

      <Content style={{ padding: "48px 0", backgroundColor: "#fff" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
        >
          <Breadcrumb
            style={{ marginBottom: "12px" }}
            items={[
              {
                title: <Link to="/">Trust Center</Link>,
              },
              {
                title: "Subprocessors",
              },
            ]}
          />

          <HeroSection
            title="Subprocessors"
            onRequestAccess={showModal}
            onSearch={onSearch}
          />

          {searchTerm ? (
            // Search Results Section
            <section style={{ marginBottom: "64px" }}>
              <div
                style={{
                  marginBottom: "8px",
                  paddingTop: "1px",
                }}
              >
                <Title level={2}>Search Results for "{searchTerm}"</Title>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  Found {searchResults.length} matching subprocessor
                  {searchResults.length !== 1 ? "s" : ""}
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {searchResults.map((subprocessor, index) => (
                    <Col xs={24} md={8} key={index}>
                      <SubprocessorCard subprocessor={subprocessor} />
                    </Col>
                  ))}
                </Row>
              </div>
            </section>
          ) : (
            // Default Sections
            <>
              <section style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>Leveraged Systems</Title>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  A cloud service or system that is FedRAMP authorized and whose
                  security capabilities are leveraged by Paramify Cloud.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {leveragedSystemsSubprocessors.map((subprocessor, index) => (
                    <Col xs={24} md={8} key={index}>
                      <SubprocessorCard subprocessor={subprocessor} />
                    </Col>
                  ))}
                </Row>
              </section>

              <section style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>Interconnections</Title>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  A direct and specific system-to-system connection between
                  Paramify Cloud, the Cloud Service Offering (CSO), and another
                  external systems or services.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {interconnectionsSubprocessors.map((subprocessor, index) => (
                    <Col xs={24} md={8} key={index}>
                      <SubprocessorCard subprocessor={subprocessor} />
                    </Col>
                  ))}
                </Row>
              </section>
            </>
          )}
        </div>
      </Content>

      <CustomFooter />

      <RequestAccessModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
      />
    </Layout>
  );
}
